import {
  AcademicCapIcon,
  BookOpenIcon,
  BuildingOffice2Icon,
  ChartBarIcon,
  ChartBarSquareIcon,
  CheckCircleIcon,
  Squares2X2Icon,
  BriefcaseIcon,
} from '@heroicons/react/24/outline';

function groupMenuItems(items) {
  return items.filter((item) => item.group).reduce((groups, item) => {
    const existing = groups.find((group) => group.label === item.group);
    if (existing) {
      existing.items.push(item);
    } else {
      groups.push({ label: item.group, items: [item] });
    }
    return groups;
  }, []);
}

function makeValidator(items) {
  const ids = new Set(items.map((item) => item.id));
  return (id) => Boolean(id && ids.has(id));
}

export const studentMenuItems = [
  { id: 'overview', label: 'My Subjects', group: null, icon: Squares2X2Icon },
  { id: 'profile', label: 'Student Profile', group: 'My Profile', icon: AcademicCapIcon },
  { id: 'academics', label: 'Department & Semester', group: 'My Profile', icon: BookOpenIcon },
  { id: 'admission', label: 'Admission Feedback', group: 'Other feedback', icon: ChartBarIcon },
];

export const facultyMenuItems = [
  { id: 'overview', label: 'My Subjects', group: null, icon: Squares2X2Icon },
  { id: 'profile', label: 'Faculty Profile', group: 'My Profile', icon: AcademicCapIcon },
  { id: 'academics', label: 'Department & Semester', group: 'My Profile', icon: BookOpenIcon },
  { id: 'reports', label: 'Performance Reports', group: 'Insights', icon: ChartBarSquareIcon },
  { id: 'statistics', label: 'Rating Statistics', group: 'Insights', icon: AcademicCapIcon },
];

export const parentMenuItems = [
  { id: 'overview', label: 'Assigned feedback', group: null, icon: Squares2X2Icon },
  { id: 'student', label: 'My student', group: 'Family', icon: AcademicCapIcon },
  { id: 'profile', label: 'Parent Profile', group: 'My Profile', icon: BriefcaseIcon },
  { id: 'academics', label: 'Work & company', group: 'My Profile', icon: BuildingOffice2Icon },
  { id: 'history', label: 'Feedback history', group: 'Archive', icon: CheckCircleIcon },
];

export const alumniMenuItems = [
  { id: 'overview', label: 'Assigned feedback', group: null, icon: Squares2X2Icon },
  { id: 'profile', label: 'Alumni Profile', group: 'My Profile', icon: AcademicCapIcon },
  { id: 'academics', label: 'Program & Placement', group: 'My Profile', icon: BookOpenIcon },
  { id: 'history', label: 'Feedback history', group: 'Archive', icon: CheckCircleIcon },
];

export const industryExpertMenuItems = [
  { id: 'overview', label: 'Assigned feedback', group: null, icon: Squares2X2Icon },
  { id: 'profile', label: 'Expert Profile', group: 'My Profile', icon: BriefcaseIcon },
  { id: 'academics', label: 'Company & Expertise', group: 'My Profile', icon: BuildingOffice2Icon },
  { id: 'history', label: 'Feedback history', group: 'Archive', icon: CheckCircleIcon },
];

export const studentMenuGroups = groupMenuItems(studentMenuItems);
export const facultyMenuGroups = groupMenuItems(facultyMenuItems);
export const parentMenuGroups = groupMenuItems(parentMenuItems);
export const alumniMenuGroups = groupMenuItems(alumniMenuItems);
export const industryExpertMenuGroups = groupMenuItems(industryExpertMenuItems);

export const isValidStudentMenuId = makeValidator(studentMenuItems);
export const isValidFacultyMenuId = makeValidator(facultyMenuItems);
export const isValidParentMenuId = makeValidator(parentMenuItems);
export const isValidAlumniMenuId = makeValidator(alumniMenuItems);
export const isValidIndustryExpertMenuId = makeValidator(industryExpertMenuItems);
